import { render, staticRenderFns } from "./summary-item.vue?vue&type=template&id=118ed4d0&"
import script from "./summary-item.vue?vue&type=script&lang=js&"
export * from "./summary-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Kentico\\Launchpad.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('118ed4d0', component.options)
    } else {
      api.reload('118ed4d0', component.options)
    }
    module.hot.accept("./summary-item.vue?vue&type=template&id=118ed4d0&", function () {
      api.rerender('118ed4d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/custom/vue/components/listing/summary-item.vue"
export default component.exports